import { BranchClient } from "@citrine/resources/branch";
import { BranchRootClient } from "@citrine/resources/branch-root";
import type { DesignWorkflow } from "@citrine/resources/design-workflow";

export function useBranchName(
  projectId: string,
  workspace: DesignWorkflow | undefined,
) {
  const branchQuery = BranchClient.getInstance(projectId).useGet(
    workspace?.branch_id,
  );
  const branchRootQuery = BranchRootClient.getInstance(projectId).useGet(
    branchQuery.data?.metadata?.root_id,
  );
  return (
    branchRootQuery.data?.data.name ??
    branchQuery.data?.data.name ??
    workspace?.name ??
    ""
  );
}
